import React, { useEffect, useState } from "react";
import DocumentPageDocPlace from "./pages";
export function DocumentListDocPlace(props) {

    const [documents, setDocuments] = useState([]);
    const [selected, setSelected] = useState();

    useEffect(() => {
        setDocuments(props.documents);
      

    


    }, [props.documents]);

    // Auto-select first document/page so the viewer is never blank.
    useEffect(() => {
        if (!documents || documents.length === 0) return;
        if (selected) return;

        const firstDoc = documents[0];
        const rawFirstPage =
            firstDoc?.pages && firstDoc.pages.length > 0 ? firstDoc.pages[0] : null;
        const parentIndex =
            typeof firstDoc?.index === "number" ? firstDoc.index : 0;
        const firstPage = rawFirstPage
            ? {
                ...rawFirstPage,
                parentIndex:
                    typeof rawFirstPage.parentIndex === "number"
                        ? rawFirstPage.parentIndex
                        : parentIndex,
                parentFileName: rawFirstPage.parentFileName || firstDoc?.fileName,
                parentPath: rawFirstPage.parentPath || firstDoc?.path,
                originalFileName:
                    rawFirstPage.originalFileName ||
                    firstDoc?.fileOriginalName ||
                    firstDoc?.originalFileName,
                fileOriginalName:
                    rawFirstPage.fileOriginalName ||
                    firstDoc?.fileOriginalName ||
                    firstDoc?.originalFileName,
              }
            : {
                // Fallback shape to avoid runtime errors in getDocument
                ...firstDoc,
                parentIndex,
                parentFileName: firstDoc?.fileName,
                parentPath: firstDoc?.path,
                originalFileName: firstDoc?.fileOriginalName || firstDoc?.originalFileName,
                fileOriginalName: firstDoc?.fileOriginalName || firstDoc?.originalFileName,
              };

        if (!firstPage) return;
        const selectedName =
            firstDoc?.fileOriginalName || firstDoc?.originalFileName || firstDoc?.fileName;
        setSelected(selectedName);
        // Use absoluteIndex if present; fallback to 0 to at least show something.
        const id = typeof firstPage.absoluteIndex === "number" ? firstPage.absoluteIndex : 0;
        props.getDocument(
            firstPage.thumbnail,
            id,
            firstPage.fileName,
            firstPage.path || firstPage.parentPath,
            firstPage.ocr,
            firstPage,
            firstPage.fileOriginalName || selectedName,
            0,
            firstPage.parentFileName
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documents, selected]);

    useEffect(() => {
        if (props.deleteOCR === true) {
            setSelected('')
        }
    }, [props.deleteOCR]);

    const ocrDoc = (doc, id, pageNumber,originalName) => {
        setSelected(originalName);
       // console.log(doc)
        props.getDocument(doc.thumbnail, id, doc.fileName, doc.path, doc.ocr, doc, doc.fileOriginalName,pageNumber)
    };

    const move = (currentIndex) => {
        props.move(currentIndex)
    };
      
//ocr.includes(props.index) && props.documents[props.index].ocr == true
    return (
      
            <div className="documentList">
                {documents && documents.map((doc, i) => (
              <div
                key={i}
                title={(selected || "") + (doc.fileOriginalName || doc.originalFileName || doc.fileName || "")}
                className={selected == (doc.fileOriginalName || doc.originalFileName || doc.fileName) ? 'documentSelected' : ''}
              >
                    <DocumentPageDocPlace document={doc} key={i} index={i} ocrDoc={ocrDoc} originalName={doc.fileOriginalName || doc.originalFileName || doc.fileName} move={move} ></DocumentPageDocPlace>
                  </div>  
                ))}

            </div>
        
    )
}

export default DocumentListDocPlace

